<template>
  <div>
    <!-- 2021.12.8游戏开始前的声明弹窗 -->
    <div v-if="showGame" close="closePop" :style="{ height: '60vh', width: '100%' }">
      <!-- 游戏声明 -->
      <div style="height: 83%" v-if="!linkUrl && !componentParams.isVer">
        <p style="text-align: center; font-weight: bold; font-size: 18px; margin-top: 15px">游戏使用声明</p>
        <div style="height: 85%; padding: 0 10px; overflow-y: scroll" class="gameState">
          <p style="text-indent: 28px">
            为了更好地保障您的个人权益，在使用我们的服务前，请您务必点击《用户协议》、《隐私政策》、《儿童隐私保护政策及监护人须知》并审慎阅读全部内容，同意并接受全部条款后方可开始使用我们的服务。
          </p>
          <p>同时请您特别注意：</p>
          <p>
            1、为了向您提供基本功能，我们会收集、使用必要的信息，并采取合理可行的技术手段存储、保护您提供的个人信息；
          </p>
          <p>
            2、基于您的明示授权，我们可能会获取您的设备信息（保护账号安全）、身份信息（用户实名制）、外部存储权限（保存账号信息）等信息，您有权拒绝或取消授权；
          </p>
          <p>
            3、请您在阅读前述协议时，特别注意其中免除或者限制我们责任的条款、对您的权利进行限制的条款、约定争议解决方式和司法管辖的条款。
          </p>
          <p>
            如您已详细阅读 <span style="color: #d3ab64" @click="openLink(1)">《用户协议》</span>、<span
              style="color: #d3ab64"
              @click="openLink(2)"
              >《隐私政策》</span
            >、<span style="color: #d3ab64" @click="openLink(3)">《儿童隐私保护政策及监护人须知》</span
            >，请点击“同意”开始使用我们的服务，若您点击“拒绝”，您将无法进入游戏。
          </p>
        </div>
      </div>
      <!-- 有更新 -->
      <div v-if="componentParams.isVer" style="height: 83%; padding: 10px">
        <iframe
          :src="componentParams.verUrl.replace('http', 'https')"
          style="width: 100%; height: 100%; overflow-y: scroll; background: #fff"
          frameborder="0"
        ></iframe>
      </div>
      <!-- 3个协议弹窗 -->
      <div style="height: 83%; padding: 0 10px" v-if="linkUrl">
        <van-icon
          name="arrow-left"
          size="30"
          style="position: absolute; top: 15px; left: -8px"
          @click="closeUserLink"
        />
        <iframe
          :src="linkUrl"
          style="width: 100%; height: 100%; overflow-y: scroll; background: #fff"
          frameborder="0"
        ></iframe>
      </div>

      <div style="display: flex; padding: 8px; justify-content: space-between">
        <van-button plain type="primary" size="small" style="width: 100px" @click="gameArgee(1)">拒绝</van-button>
        <van-button type="primary" size="small" style="width: 100px; margin-left: 10px" @click="gameArgee(2)"
          >同意</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getUrlParams } from '@/utils';
import server from '@/server/index';
import mixServer from '@/server/mixServer';
import store from '@/store';
export default {
  data() {
    return {
      showGame: false,
      linkUrl: '',
    };
  },
  computed: {
    ...mapState(['componentParams', 'gameState', 'gameStateVer']),
  },
  created() {
    // 初始加载获取用户协议同意状态
    console.log(this.componentParams);
    let userLink = localStorage.getItem('ln_agree');
    if (userLink == 2) {
      if (this.gameStateVer != '') {
        this.showGame = true;
      } else {
        store.commit('SET_GAMESTATE', true);
        this.showGame = false;
        server.init(); // 同意过则进入sdk
      }
    } else {
      this.showGame = true;
      store.commit('SET_GAMESTATE', false);
    }
  },
  methods: {
    // 同意则继续
    gameArgee(type) {
      store.commit('SET_GAMESTATE', type == 1 ? false : true);
      // 存储玩家同意拒绝状态
      localStorage.setItem('ln_agree', type);
      // 有更新后存储玩家同意拒绝状态
      if (this.componentParams.status && this.componentParams.status == 1) {
        localStorage.setItem('ln_status', type);
      }
      if (type == 2) {
        // if (getUrlParams('appid') != '70652' && getUrlParams('appid') != '70660') {
        //   // 同意后请求红包前置接口
        //   mixServer.getConfig().then((data_conf) => {
        //     store.commit('SET_OPEN_HEALTH', data_conf.data.is_open_health);
        //     mixServer.init().then((data_init) => {
        //       mixServer.getPreRebate({ access_token: data_init.data.access_token }).then((data_rb) => {
        //         if (data_rb.url) {
        //           store.commit('SET_PRERB', true);
        //           store.commit('SET_PRERBURL', data_rb.url);
        //         } else {
        //           if (data_conf.data.is_open_health == 1) {
        //             store.commit('SET_HEALTH', true);
        //             store.commit('SET_GAMEDIST', data_conf.data.direction);
        //             setTimeout(() => {
        //               store.commit('SET_HEALTH', false);
        //               server.init();
        //             }, 2000);
        //           } else {
        //             server.init();
        //           }
        //         }
        //       });
        //     });
        //   });
        // } else {
        server.init();
        // }
        // 通过ios获取巨量sdk
        try {
          window.webkit.messageHandlers['BDStart'].postMessage({});
        } catch (err) {
          console.log('浏览器不支持', err);
        }
      }
      this.$store.commit('CLOSE');
      this.showGame = false;
    },
    // 打开协议
    openLink(type) {
      this.linkUrl =
        type == 1
          ? `https://apisdk.lnqwe.com/uc/user/user_protocol?appid=${getUrlParams('appid')}&ad_ver=${getUrlParams(
              'campaign_id'
            )}`
          : type == 2
          ? `https://apisdk.lnqwe.com/uc/user/privacy_protocol?appid=${getUrlParams('appid')}&ad_ver=${getUrlParams(
              'campaign_id'
            )}`
          : `https://apisdk.lnqwe.com/uc/user/children_protocol?appid=${getUrlParams('appid')}&ad_ver=${getUrlParams(
              'campaign_id'
            )}`;
    },
    closeUserLink() {
      this.linkUrl = '';
    },
  },
};
</script>
<style>
.gameState p {
  font-size: 14px;
  color: #000;
}
</style>
